<div class="dialog">
  <div class="dialog__header">
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <span>Selecione uma conta habilitada para geração de boleto:</span>
  <div class="dialog__content" mat-dialog-content>
    <form class="dialog__container">
      <div class="input-container">
        <app-input-select-autocomplete label="Conta" [formControl]="bankAccountControl" optionLabel="accountFullName"
          [options]="bankAccounts" placeholder="Selecione a conta" style="width: 100%;">
        </app-input-select-autocomplete>
      </div>
    </form>
  </div>
  <div class="dialog__actions">
    <button mat-flat-button class="btn-default btn" type="button" (click)="generateBoleto()">
      <span>Gerar</span>
    </button>
    <button class="dialog__cancel" mat-flat-button mat-dialog-close (click)="onCancel()">
      <span>Cancelar</span>
    </button>
  </div>
</div>